import React from "react";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ErrorMessage } from "widgets";
import Loader from "Shared/Loader/Loader";
import { PROGRAM_STATUS, getSkipReasonLabel } from "constants/batchPreference";
import {
  formatStartDate,
  getBatchScheduleDayTimeLabels,
  getStartDateStatus,
} from "utils/batchPreferenceUtils";
import BatchCard from "./BatchCard";

import styles from "./BatchPreference.module.scss";

const ResolvedProgram = ({ program }) => {
  if (program.status === PROGRAM_STATUS.SKIPPED) {
    return (
      <div className={styles.resolvedBox}>
        <p className={styles.resolvedStatus}>Skipped</p>
        <p>{getSkipReasonLabel(program.decision?.skipReasonCode)}</p>
        {program.decision?.skipReasonDetail ? (
          <p className={styles.additionalInfo}>
            {program.decision.skipReasonDetail}
          </p>
        ) : null}
      </div>
    );
  }

  return (
    <div className={styles.resolvedBox}>
      <p className={styles.resolvedStatus}>
        <CheckCircleOutlineIcon className={styles.resolvedStatusIcon} />
        Confirmed
      </p>
      <p>{program.decision?.batchLabel}</p>
      <ul className={styles.scheduleList}>
        {getBatchScheduleDayTimeLabels(program.decision).map(
          (dayTimeLabel, index) => (
            <li
              key={`${index}-${dayTimeLabel}`}
              className={styles.scheduleListItem}
            >
              <span>{dayTimeLabel}</span>
            </li>
          ),
        )}
      </ul>
      <p>
        {formatStartDate(program.decision?.startDate)} ·{" "}
        {getStartDateStatus(program.decision?.startDate)}
      </p>
    </div>
  );
};

const ProgramBatchTab = ({
  program,
  schedules,
  isLoading,
  isError,
  error,
  onSelectBatch,
}) => {
  if (program.status !== PROGRAM_STATUS.PENDING) {
    return <ResolvedProgram program={program} />;
  }

  if (isLoading) {
    return (
      <div className={styles.loaderWrap}>
        <Loader />
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles.emptyState}>
        <ErrorMessage>
          {error?.message || "Unable to load schedules for this Program."}
        </ErrorMessage>
      </div>
    );
  }

  if (!schedules.length) {
    return (
      <div className={styles.emptyState}>
        <p>No suitable schedule is available for this Program.</p>
      </div>
    );
  }

  return (
    <section className={styles.batchesSection}>
      <h3 className={styles.sectionTitle}>Available Batches</h3>
      <div className={styles.batchGrid}>
        {schedules.map((batch) => (
          <BatchCard key={batch.id} batch={batch} onSelect={onSelectBatch} />
        ))}
      </div>
    </section>
  );
};

export default ProgramBatchTab;
